import setupCannedAutotags from './canned-autotags';
import instalMessagingInQueue from './messaging-in-queue';
import instalMessagingMode from './messaging-mode';

export const plugins = [instalMessagingInQueue, instalMessagingMode, setupCannedAutotags];
